import { Attachment, cnAttachment } from '../Attachment/Attachment';
export { Attachment, cnAttachment } from '../Attachment/Attachment';
/**
 * @deprecated since version 3.2.0 use Attachment
 */
var Attach = Attachment;
/**
 * @deprecated since version 3.2.0 cnAttachment
 */
var cnAttach = cnAttachment;
export { Attach, cnAttach };
